export enum PriceListRoutes {
  NOT_FOUND = '404',
  FORBIDDEN = 'forbidden',
}
